import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { toast } from "react-toastify";
import { loginWithAdminToken } from "../../Utils/adminLogin";

/**
 * Admin Login Handler Component
 * This component handles the admin login flow when called from admin panel
 * Usage: /admin-auth?token=YOUR_ADMIN_TOKEN&redirect_url=/admin/tenant/123
 */
const AdminAuthHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const adminToken = searchParams.get("token");
    const redirectUrl = searchParams.get("redirect_url");
    const usertype = searchParams.get("usertype");
    const saveduserid = searchParams.get("saveduserid");
    const isAdminUser = searchParams.get("isAdminUser");
    const loggedin_by = searchParams.get("loggedin_by");

    if (adminToken) {
      // Set up admin session
      localStorage.setItem("admin_token", adminToken);
      localStorage.setItem("token", adminToken);
      localStorage.setItem("usertype", usertype || "admin");
      localStorage.setItem("saveduserid", saveduserid || "");
      localStorage.setItem("loggedin_by", loggedin_by || "admin");
      localStorage.setItem("is_verified", "true");

      if (isAdminUser === "true") {
        localStorage.setItem("isAdminUser", "true");
      }

      // Use the redirect_url from query params, or fall back to localStorage, or default to home
      const redirectPath =
        redirectUrl || localStorage.getItem("admin_redirect_path") || "/home";

      localStorage.removeItem("admin_redirect_path");

      // Navigate to the specified path
      navigate(redirectPath);
    } else {
      // No token provided, redirect to home
      toast.error("No admin token provided.");
      navigate("/home");
    }
  }, [searchParams, navigate]);

  return (
    <div className="container text-center mt-5">
      <h3>Logging in as Admin...</h3>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default AdminAuthHandler;
